import { formatDuration, intervalToDuration } from 'date-fns'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type Props = {
  refreshIntervalMs: number
}

export const LiveIndicator = ({ refreshIntervalMs }: Props) => {
  const interval = formatDuration(
    intervalToDuration({ start: 0, end: refreshIntervalMs })
  )

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex cursor-default items-center gap-1.5 text-xs font-medium text-muted-foreground">
            <span
              aria-hidden
              className="size-2 animate-pulse rounded-full bg-emerald-500"
            />
            Live
          </div>
        </TooltipTrigger>
        <TooltipContent>
          Charts update automatically every {interval}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
